import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserPermissions, PermissionConditionObj } from '../menu/types';
import { IPermissions } from '../interfaces/IProfile';
import { HttpService } from 'src/app/core/services/http.service';
import { IGroup } from 'src/app/core/common/interfaces';
const TOKEN_HEADER_KEY = 'Authorization';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _urlAccessControl = 'accounts/is-authenticated/';
  public userPermissions: UserPermissions = {};
  public onPermissionsUpdated$ = new BehaviorSubject<UserPermissions>({});
  public getPermissions = this.onPermissionsUpdated$.asObservable();
  constructor(private http: HttpService) {}

  // getUserAccessContrlsApi(VID?: number): Observable<UserPermissions> {
  //   return this._httpClient.get<UserPermissions>(this._urlAccessControl, {
  //     headers: { "Authorization": localStorage.getItem('access_token') },
  //     params: VID ? { VID } : undefined
  //   }).pipe(map((data: any): UserPermissions => {
  //     return data.data
  //   }))
  // }

  // async updatePermissions() {
  //   console.log(this._env.profileInfo)
  //   const userPermissions :UserPermissions = {permissions:this._env.profileInfo.permissions.map(permission=>permission.name),
  //                                             groups:this._env.profileInfo.groups}

  //   this.userPermissions = userPermissions;
  //   this.onPermissionsUpdated$.next(userPermissions)
  //   return userPermissions
  // }

  hasPermission(userPermissions: string[], permissions: string[], checkAll: boolean = false): boolean {
    if (checkAll) {
      for (const permission of permissions) {
        if (!userPermissions?.includes(permission)) {
          return false
        }
      }

      return true;
    } else {
      for (const permission of permissions) {
        if (userPermissions?.includes(permission))
          return true
      }
      return false;
    }
  }

  public createPermissionObj(items: PermissionConditionObj, userPermissions: UserPermissions): { [key: string]: boolean } {
    const permissions = {}
    Object.entries(items).forEach(([key, value]) => {
      permissions[key] = this.hasPermission(userPermissions.permissions, value.permissions, value.checkAll)
      if (!value.notBeAdmin)
        permissions[key] = userPermissions.all || permissions[key];
    })
    return permissions;
  }

  isAuthenticated(): boolean {
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus) {
      return authStatus === "true"
    } else {
      return false;
    }
  }




  //--------------- New AuthService Methods --------------------
  async setPermission(permissions: IPermissions[], groups: IGroup[]) {
    const permissionsList = permissions.map((permision) => permision.name); 
    this.userPermissions = {
      permissions: permissionsList,
      groups: groups?.map(group=> group.name),
      all: permissionsList?.includes('full_access') ? true : false,
    };
    this.onPermissionsUpdated$.next(this.userPermissions);
  }

  getUserAccessContrlsApi() {
      return this.http.getSuccessResult<UserPermissions>({
        method:'GET',
        path: this._urlAccessControl,
      })
  }

  async updatePermissions() {
    let res = await this.getUserAccessContrlsApi()
    if (res.statusCode === 200){
      this.userPermissions = res.data
      this.onPermissionsUpdated$.next(this.userPermissions);
    }
      return this.userPermissions;
  }
}
